// src/store/slices/busRoutesSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  searchParams: {
    fromCityVillageCode: '',
    toCityVillageCode: '',
  },
  busRoutes: [],
  groupedRoutes: [],
  busRoutesMap: {},
  arrivalData: [],
  fullApiResponse: null,
  filter: 'all',
  searchTerm: '',
  hasSearched: false,
};

const busRoutesSlice = createSlice({
  name: 'busRoutes',
  initialState,
  reducers: {
    setSearchParams(state, action) {
      state.searchParams = action.payload;
    },
    setSearchResults(state, action) {
      const {
        busRoutes,
        groupedRoutes,
        busRoutesMap,
        arrivalData,
        fullApiResponse,
      } = action.payload;
      state.busRoutes = busRoutes;
      state.groupedRoutes = groupedRoutes;
      state.busRoutesMap = busRoutesMap;
      state.arrivalData = arrivalData;
      state.fullApiResponse = fullApiResponse;
      state.hasSearched = true;
    },
    setFilter(state, action) {
      state.filter = action.payload;
    },
    setSearchTerm(state, action) {
      state.searchTerm = action.payload;
    },
    resetSearch() {
      return { ...initialState };
    },
  },
});

export const {
  setSearchParams,
  setSearchResults,
  setFilter,
  setSearchTerm,
  resetSearch,
} = busRoutesSlice.actions;

export default busRoutesSlice.reducer;